var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurvaluesvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8918 28.5263C21.737 28.2223 24.6077 24.8588 24.3037 21.0137C23.9998 17.1685 20.6363 14.2978 16.7911 14.6018C12.946 14.9057 10.0753 18.2692 10.3792 22.1144C10.6831 25.9595 14.0467 28.8302 17.8918 28.5263Z",
    stroke: "#000064",
    strokeWidth: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5258 36.7529L17.9756 40.9999C11.0546 39.1123 -1.55712 30.6181 1.93148 8.91155C10.4254 5.13646 12.313 4.66457 17.9756 1.83325L33.076 8.43967C34.4917 13.6304 34.0198 21.1807 32.1322 26.3714",
    stroke: "#000064",
    strokeWidth: 2.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5664 26.0037L29.7618 32.1243",
    stroke: "#000064",
    strokeWidth: 2.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurvaluesvg3);
export default __webpack_public_path__ + "static/media/ourvaluesvg3.60b3c7819ba86f84e534b1f276928224.svg";
export { ForwardRef as ReactComponent };